import type { LeadRejectionReason } from "@/lib/db-types";

/** Årsaker til «Avvist» (VIB-3032, VIB-3050). Rekkefølgen er rekkefølgen i dialogen. */
export const LEAD_REJECTION_REASONS: { value: LeadRejectionReason; label: string }[] = [
  { value: "has_supplier", label: "Har leverandør" },
  { value: "has_video", label: "Har nok video" },
  { value: "not_now", label: "Ikke nå (tid eller budsjett)" },
  { value: "no_need", label: "Ser ikke behovet" },
  { value: "group_decides", label: "Konsernet bestemmer" },
  { value: "not_target", label: "Utenfor målgruppen" },
  { value: "other", label: "Annet" },
];

export const LEAD_REJECTION_REASON_LABELS: Record<string, string> = Object.fromEntries(
  LEAD_REJECTION_REASONS.map((r) => [r.value, r.label]),
);

/** Valg for revurdering i måneder. 0 = aldri (avsluttet for godt). */
export const REVISIT_OPTIONS: { months: number; label: string }[] = [
  { months: 3, label: "Om 3 måneder" },
  { months: 6, label: "Om 6 måneder" },
  { months: 12, label: "Om 1 år" },
  { months: 0, label: "Aldri" },
];

export const DEFAULT_REVISIT_MONTHS = 6;

/** Revurderingsdato som YYYY-MM-DD, `months` måneder etter `today` (lokal dato). null for «aldri». */
export function revisitDate(months: number, today: Date = new Date()): string | null {
  if (months <= 0) return null;
  const d = new Date(today.getFullYear(), today.getMonth() + months, today.getDate());
  // 31. august + 6 måneder blir 3. mars i Date; bruk heller siste dag i målmåneden.
  if (d.getDate() !== today.getDate()) d.setDate(0);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** Om et avvist lead skal vurderes nå: datoen er i dag eller passert. */
export function isRevisitDue(revisitOn: string | null, today: Date = new Date()): boolean {
  if (!revisitOn) return false;
  const pad = (n: number) => String(n).padStart(2, "0");
  const t = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
  return revisitOn <= t;
}

export type RejectionBucket = "due" | "waiting" | "closed";

/** Til vurdering (dato passert), venter (dato frem i tid) eller avsluttet (ingen dato). */
export function rejectionBucket(revisitOn: string | null, today: Date = new Date()): RejectionBucket {
  if (!revisitOn) return "closed";
  return isRevisitDue(revisitOn, today) ? "due" : "waiting";
}
